////////////////////////////////////////////////////////////////////////
// Import
////////////////////////////////////////////////////////////////////////
import { LSData } from "@/common/class/LSData";

////////////////////////////////////////////////////////////////////////
// Setting
////////////////////////////////////////////////////////////////////////
const LOCAL_STORAGE_KEY = process.env.VUE_APP_LOCAL_STORAGE_KEY ?? "terra";

////////////////////////////////////////////////////////////////////////
// Variable
////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////
// Function
////////////////////////////////////////////////////////////////////////

////////////////////////////////////
// LSData
////////////////////////////////////

/**
 * 로컬스토리지 데이터 전체 조회
 * @returns
 */
export const getLSData = (): LSData => {
  let data = "{}";
  try {
    data = localStorage.getItem(LOCAL_STORAGE_KEY) || "{}";
    if (data === "{}") {
      setLSData(new LSData());
    }
  } catch (e) {
    console.error("LocalStorage getLSData fail : ", e);
  }
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
};

/**
 * 로컬 스토리지 데이터 전체 저장
 * @param lsData
 */
export const setLSData = (lsData: LSData) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(lsData));
};

export const setLSLoginId = (id: string) => {
  const lsData = getLSData();
  lsData.rememberId = id;
  setLSData(lsData);
};

//
//
//
export const clearLSLoginId = () => {
  const lsData = getLSData();
  lsData.rememberId = "";
  setLSData(lsData);
};

export const getLoginId = () => {
  const lsData = getLSData();
  return lsData.rememberId || "";
};
